import React, { useState, useEffect } from 'react';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import InvitationCard from './components/InvitationCard';
import HeroSection from './components/HeroSection';
import CountdownTimer from './components/CountdownTimer';
import RSVPCallToAction from './components/RSVPCallToAction';
import EventDetails from './components/EventDetails';
import DressCode from './components/DressCode';
import RSVPSection from './components/RSVPSection';
import Footer from './components/Footer';
import LanguageToggle from './components/LanguageToggle';
import AdminPage from './components/AdminPage';
import { motion, AnimatePresence } from 'framer-motion';
import './App.css';

const MainContent = () => {
  const { hasSelectedLanguage } = useLanguage();

  return (
    <>
      {/* Invitation Card - Shows first, blocks site until language selected */}
      <InvitationCard />
      
      {/* Main Site Content - Only visible after language selection */}
      <AnimatePresence>
        {hasSelectedLanguage && (
          <motion.div 
            className="min-h-screen bg-[#FFF8F0]" 
            data-testid="wedding-app"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            {/* Persistent Language Toggle */}
            <LanguageToggle />
            
            {/* Hero Section with Photos */}
            <HeroSection />
            
            {/* Countdown Timer */}
            <CountdownTimer />
            
            {/* Prominent RSVP Call-to-Action */}
            <RSVPCallToAction />
            
            {/* Event Details Section */}
            <EventDetails />
            
            {/* Dress Code Section */}
            <DressCode />
            
            {/* RSVP Section */}
            <RSVPSection />
            
            {/* Footer */}
            <Footer />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

function App() {
  const [showAdmin, setShowAdmin] = useState(false);

  // Check URL for admin access
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('admin') === 'true') {
      setShowAdmin(true);
    }
  }, []);

  // Show admin page (outside of LanguageProvider since admin doesn't need translations)
  if (showAdmin) {
    return (
      <AdminPage 
        onBack={() => {
          setShowAdmin(false);
          window.history.pushState({}, '', window.location.pathname);
        }} 
      />
    );
  }

  return (
    <LanguageProvider>
      <MainContent />
    </LanguageProvider>
  );
}

export default App;
